import { IQuery } from '@spree/storefront-api-v2-sdk/types/interfaces/Query'

export const cartParams: IQuery = {
  include:
    'line_items.variant.images,bill_address,ship_address,order_promotions,shipments,payments,user,user.spree_roles',
}
